export {type PartialNode} from '../../../src/collections/types';
